import React from 'react';
import translate from '../../i18n/translate';

/**
 * Benefits — six stakeholder cards matching the personas walked in /docs:
 * researcher · contributor · auditor · holder · oracle · beneficiary.
 * Icons reused from public/images/icons/actor-*.svg + badge-*.svg for the
 * two new personas (holder, oracle). Proper icon set queued for the
 * document-format pass — see Roadmap v2 Section 4.
 */
const ROLES = [
  { numKey:'lv2-benefits-1-num', subKey:'benefits-1-sub', desKey:'benefits-1-des', tag:'AuditingPool · live',        icon:'/images/icons/actor-researcher.svg',  alt:'Researchers' },
  { numKey:'lv2-benefits-2-num', subKey:'benefits-2-sub', desKey:'benefits-2-des', tag:'MethaCrowdsale · live',      icon:'/images/icons/actor-contributor.svg', alt:'Contributors' },
  { numKey:'lv2-benefits-3-num', subKey:'benefits-3-sub', desKey:'benefits-3-des', tag:'AuditorRegistryV2 · live',   icon:'/images/icons/actor-auditor.svg',     alt:'Auditors' },
  { numKey:'lv2-benefits-5-num', subKey:'benefits-5-sub', desKey:'benefits-5-des', tag:'OpenGovernance · live',      icon:'/images/icons/badge-network.svg',     alt:'Holders' },
  { numKey:'lv2-benefits-6-num', subKey:'benefits-6-sub', desKey:'benefits-6-des', tag:'Compliance · oracle role',   icon:'/images/icons/badge-license.svg',     alt:'Oracles' },
  { numKey:'lv2-benefits-4-num', subKey:'benefits-4-sub', desKey:'benefits-4-des', tag:'Beneficiaries · settlement', icon:'/images/icons/actor-user.svg',        alt:'Final users' },
];

export default function Benefits() {
  return (
    <section className="lv2-section" id="benefits" style={{ paddingTop: 0 }}>
      <div className="lv2-shell">
        <div className="lv2-section-head">
          <span className="lv2-section-tag">{translate('lv2-benefits-tag')}</span>
          <h2>{translate('lv2-benefits-h2')}</h2>
          <p className="sub">{translate('lv2-benefits-sub')}</p>
        </div>

        <div className="lv2-benefits-grid">
          {ROLES.map(r => (
            <article key={r.numKey} className="lv2-benefit-card">
              <img className="lv2-benefit-icon" src={r.icon} alt={r.alt} />
              <span className="num">{translate(r.numKey)}</span>
              <h3>{translate(r.subKey)}.</h3>
              <p>{translate(r.desKey)}</p>
              <span className="tag">{r.tag}</span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
